import PropTypes from 'prop-types';
import React from 'react';

import PersonCardCoupleSelect from '../personCardCoupleSelect';

const CoupleSelectTabPanel = ({
  onPartnerSelect,
  onSelect,
  partnerRequired,
  people,
  allPeople,
  personGroup,
  selectedPartnerByGroup,
  selectedPersonByGroup,
}) => {
  if (personGroup == null) {
    return null;
  }
  return (
    <PersonCardCoupleSelect
      onPartnerSelect={onPartnerSelect}
      onSelect={onSelect}
      partnerRequired={partnerRequired}
      people={people}
      allPeople={allPeople}
      selectedPartner={selectedPartnerByGroup[personGroup.id]}
      selectedPerson={selectedPersonByGroup[personGroup.id]}
    />
  );
};

CoupleSelectTabPanel.defaultProps = {
  onPartnerSelect: () => {},
  onSelect: () => {},
  partnerRequired: false,
  people: [],
  allPeople: undefined,
  personGroup: undefined,
};

CoupleSelectTabPanel.propTypes = {
  onPartnerSelect: PropTypes.func,
  onSelect: PropTypes.func,
  partnerRequired: PropTypes.bool,
  people: PropTypes.arrayOf(PropTypes.object),
  allPeople: PropTypes.arrayOf(PropTypes.object),
  personGroup: PropTypes.object,
  selectedPartnerByGroup: PropTypes.objectOf(PropTypes.object).isRequired,
  selectedPersonByGroup: PropTypes.objectOf(PropTypes.object).isRequired,
};

export default CoupleSelectTabPanel;
